export const debounce = (fn: any, wait: any) => {
    let searchTimer: NodeJS.Timeout;
    return (...args: any) => {
        if (searchTimer) {
            clearTimeout(searchTimer); // clear any pre-existing searchTimer
        }

        searchTimer = setTimeout(() => {
            fn(...args); // call the function if time expires
        }, wait);
    };
};
